import firebase from 'firebase/app';
import 'firebase/auth'
import 'firebase/database'
import dbJson from '../config/firebaseconnection.json'

const config = {
    apiKey: "AIzaSyDW4qaDVf5NeG64B8gTmjzzaH6biWywuZ0",
    authDomain: "raidroster-73e80.firebaseapp.com",
    projectId: "raidroster-73e80",
    storageBucket: "raidroster-73e80.appspot.com",
    messagingSenderId: "936265694683",
    appId: "1:936265694683:web:7e1b66debe80af27dd3bfe",

    databaseURL: dbJson.url,
};

// Get a RTDB instance
const db = firebase.initializeApp( config ).database();

export default db;

